<sb-card classes="green-border">
  <div card-header>
    <h1>{{ 'lang.dashboard.networkOverview' | translate }}</h1>
    <small>{{ 'lang.reporting.time' | translate }} {{ date.toString() | date : 'dd.MM.yyyy | HH:mm' }}</small>
  </div>
  <div card-header-more>
    <a *ngPermissions="[permissionService.Permission.ss_fm_reporting, permissionService.Permission.ss_nm_reporting]"
       [sbRouterLink]="util.RoutingID.playerReporting">
      <ng-container *sbPageAction></ng-container>
      <button class="btn btn-primary btn-sm">{{ 'lang.dashboard.showNetworkReporting' | translate }}</button>
    </a>
  </div>
  <div card-body>
    <h6 class="pt-3 mb-3">{{ 'lang.globals.playerStatus' | translate }}</h6>
    <div class="widget pb-5 border-dashed-bottom">
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.player' | translate }}</div>
          <div class="val"><span
            class="blue mr-3">{{ (networkData?.deviceStatus?.total ? networkData?.deviceStatus?.total : 0)| sbNumberFormat }}</span></div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.playerStatusOnline' | translate }}</div>
          <div class="val"><span
            class="green mr-3">{{ networkData?.deviceStatus?.quotaOnlineStatus_Online + networkData?.deviceStatus?.quotaOnlineStatus_CurrentlyOffline | sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.dashboard.planOffline' | translate }}</div>
          <div class="val"><span
            class="orange mr-3">{{ (networkData?.deviceStatus?.quotaOnlineStatus_PlannedOffline ? networkData?.deviceStatus?.quotaOnlineStatus_PlannedOffline : 0) | sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.playerStatusOffline' | translate }}</div>
          <div class="val"><span
            class="red mr-3">{{ (networkData?.deviceStatus?.quotaOnlineStatus_Offline ? networkData?.deviceStatus?.quotaOnlineStatus_Offline : 0)| sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.unknown' | translate }}</div>
          <div class="val"><span
            class="grey mr-3">{{ (networkData?.deviceStatus?.quotaOnlineStatus_Unknown ? networkData?.deviceStatus?.quotaOnlineStatus_Unknown : 0)| sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
    </div>
    <h6 class="pt-4 mb-3">{{ 'lang.globals.locationstatus' | translate }}</h6>
    <div class="widget pb-5">
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.locations' | translate }}</div>
          <div class="val"><span
            class="blue mr-3">{{ (locationData?.onlineStatus?.total ? locationData?.onlineStatus?.total : 0) | sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.locationstatusOnline' | translate }}</div>
          <div class="val"><span
            class="green mr-3">{{ (locationData?.onlineStatus?.quotaAllOnline ? locationData?.onlineStatus?.quotaAllOnline : 0)| sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.mixed' | translate }}</div>
          <div class="val"><span
            class="yellow mr-3">{{ (locationData?.onlineStatus.total - locationData?.onlineStatus.quotaUnknown) - locationData?.onlineStatus.quotaAllOffline - locationData?.onlineStatus.quotaAllOnline | sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.locationstatusOffline' | translate }}</div>
          <div class="val"><span
            class="red mr-3">{{ (locationData?.onlineStatus?.quotaAllOffline ? locationData?.onlineStatus?.quotaAllOffline : 0) | sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
      <div class="widget__info">
        <sb-info-text>
          <div class="heading">{{ 'lang.globals.unknown' | translate }}</div>
          <div class="val"><span
            class="grey mr-3">{{ (locationData?.onlineStatus?.quotaUnknown ? locationData?.onlineStatus?.quotaUnknown : 0)| sbNumberFormat }}</span>
          </div>
        </sb-info-text>
      </div>
    </div>
    <!--
    <sb-comp-airtime-reporting-header></sb-comp-airtime-reporting-header>
  </div>
  <div card-fit>
    <sb-comp-airtime-data [resolveInCom]="true" [integratedChart]="true"></sb-comp-airtime-data>
    -->
  </div>
</sb-card>
